<template>
    <div id="booking-payment-container" class="shadow-reg">
        <h6 class="heading-small text-muted text-uppercase montserrat mb-2">Payment Information</h6>
        <div class="payment-breakdown-container">
            <div class="payment-item text-default text-sm">
                Service Cost: <span class="price" v-text="serviceCost.toFixed(2)"></span>
            </div>
            <div class="payment-item text-default text-sm">
                VAT: <span class="price" v-text="vat.toFixed(2)"></span>
            </div>
            <div class="payment-item text-default text-sm">
                Booking Fee: <span class="price" v-text="bookingFee.toFixed(2)"></span>
            </div>
            <div class="payment-item text-default text-sm">
                Points Discount: <span class="price" v-text="(-1 * pointsDiscount).toFixed(2)"></span>
            </div>
            <div class="payment-item text-default text-sm">
                Voucher Discount: <span class="price" v-text="(-1 * voucherDiscount).toFixed(2)"></span>
            </div>
            <div v-if="penalties > 0" class="payment-item text-default text-white bg-danger text-sm font-weight-700">
                Penalties: <span class="price" v-text="penalties.toFixed(2)"></span>
            </div>
            <div class="payment-item text-white bg-success text-sm font-weight-700">
                Transaction Cost: <span class="price" v-text="totalCost.toFixed(2)"></span>
            </div>
            <div class="payment-item text-default text-sm">
                Amount Paid: <span class="price" v-text="amountPaid.toFixed(2)"></span>
            </div>
            <div v-if="amountDue > 0" class="payment-item text-default text-white bg-warning text-sm font-weight-700">
                Amount Due: <span class="price" v-text="amountDue.toFixed(2)"></span>
            </div>
        </div>
    </div>
</template>
<script>
import { getPointsDiscount, getPenaltiesPrice, getBookingVoucherDiscount,
    getTotalServiceVoucherDiscount, getAmountPaid, getTotalCost } from "./helpers/booking";

export default {
    name: "BookingPaymentSection",

    computed: {
        serviceCost() {
            return parseFloat(this.booking.service_cost || 0);
        },

        vat() {
            return parseFloat(this.booking.vat || 0);
        },

        bookingFee() {
            return parseFloat(this.booking.booking_fee || 0);
        },

        pointsDiscount() {
            return getPointsDiscount(this.booking.points_used, this.booking.point_mechanic);
        },

        penalties() {
            let penalties = this.booking.paid_at != null
                ? this.booking.settled_penalties
                : this.booking.unsettled_penalties;

            return getPenaltiesPrice(this.booking.status, penalties || []);
        },

        voucherDiscount() {
            if (this.booking.discount_code != null) {
                // Booking voucher
                const discount = getBookingVoucherDiscount(this.serviceCost, {
                    discount_type: this.booking.discount_code_type,
                    amount: parseFloat(this.booking.discount_code_amount || 0),
                });

                return discount || 0;
            }
            // Service vouchers
            return getTotalServiceVoucherDiscount(this.booking.services || []) || 0;
        },

        totalCost() {
            const bookingVoucherDiscount = this.booking.discount_code != null ? this.voucherDiscount : 0;
            const total = getTotalCost(this.serviceCost, this.vat, this.bookingFee, this.penalties, this.pointsDiscount, bookingVoucherDiscount);

            return total || 0;
        },

        amountPaid() {
            return getAmountPaid(this.booking.settled_payments || []) || 0;
        },

        amountDue() {
            return parseFloat(this.totalCost - this.amountPaid) || 0;
        },
    },

    props: {
        booking: Object,
    }
}
</script>